import { MetadataModel } from '@thehubz/client/core';
import { AssetMetadata } from '@thehubz/shared/model';

export const MandatoryField: MetadataModel[] = [
  {
    formControlName: '_id',
    formFieldName: $localize`Asset Id`,
    selected: true,
  },
  {
    formControlName: 'name',
    formFieldName: $localize`Name`,
    selected: true,
  },
  {
    formControlName: 'status',
    formFieldName: $localize`Status`,
    selected: true,
  },
  {
    formControlName: 'assetType',
    formFieldName: $localize`Asset type`,
    selected: true,
  },
  {
    formControlName: 'assetCategory',
    formFieldName: $localize`Asset category`,
    selected: true,
    customField: true,
  },
  {
    formControlName: 'agency',
    formFieldName: $localize`Agency`,
    selected: true,
  },
  {
    formControlName: 'client',
    formFieldName: $localize`Client`,
    selected: true,
  },
  {
    formControlName: 'brand',
    formFieldName: $localize`Brand`,
    selected: true,
  },
  {
    formControlName: 'createdAt',
    formFieldName: $localize`Created at`,
    selected: true,
  },
  {
    formControlName: 'createdBy',
    formFieldName: $localize`Created by`,
    selected: true,
  },
  {
    formControlName: AssetMetadata.General.TAGS,
    formFieldName: $localize`Tags`,
    selected: true,
  },
  {
    formControlName: 'customFields',
    formFieldName: $localize`Custom fields`,
    selected: true,
    hideField: true,
  },
];

export const NonMandatoryField: MetadataModel[] = [
  {
    formControlName: 'clientContact',
    formFieldName: $localize`Licensee/Client contact`,
    customField: true,
  },
  {
    formControlName: 'jobNumber',
    formFieldName: $localize`Job number`,
  },
  {
    formControlName: 'description',
    formFieldName: $localize`Description`,
  },
  {
    formControlName: 'productionDetails',
    formFieldName: $localize`Production details`,
    customField: true,
  },
  {
    formControlName: 'relations',
    formFieldName: $localize`Relations`,
    customField: true,
  },
  {
    formControlName: 'makeBuyoutRights',
    formFieldName: $localize`Buyout rights`,
    formFieldGroup: [
      {
        formControlName: 'creators',
        formFieldName: $localize`Creators`,
      },
      {
        formControlName: 'cast',
        formFieldName: $localize`Cast`,
      },
      {
        formControlName: 'voiceover',
        formFieldName: $localize`Voice over`,
      },
      {
        formControlName: 'music',
        formFieldName: $localize`Music`,
      },
      {
        formControlName: 'stock',
        formFieldName: $localize`Stock`,
      },
      {
        formControlName: 'others',
        formFieldName: $localize`Other`,
      },
      {
        formControlName: 'notes',
        formFieldName: $localize`Notes`,
      },
    ],
  },
];
